<template>
  <div>
    <Footer />
  </div>
</template>

<script lang="ts">
import Footer from '../../components/shared/Footer.vue';
export default {
  components: {
    Footer,
  },
};
</script>